import { useEffect, useState } from 'react';
import { CatalogLanguage, LanguageCode } from '../Models/Models';
import { loadLanguageCatalog } from '../Services/WebsiteLanguageService';

let cached: Map<LanguageCode, CatalogLanguage> | null = null;

/** All selectable languages keyed by code; null until the (session-cached) catalog arrives. */
export function useLanguageCatalog(): Map<LanguageCode, CatalogLanguage> | null {
    const [catalog, setCatalog] = useState(cached);

    useEffect(() => {
        if (cached) return;
        let alive = true;
        loadLanguageCatalog()
            .then(list => {
                cached = new Map(list.map(l => [l.code, l]));
                if (alive) setCatalog(cached);
            })
            .catch(() => { /* flags fall back to the code badge */ });
        return () => { alive = false; };
    }, []);

    return catalog;
}
